<template>
  <div class="input-form">
    <a-card title="输入参数" size="small">
      <a-form :model="localFormData" layout="vertical">
        <a-form-item label="故障现象" required>
          <!-- 只读模式：显示文本 -->
          <div v-if="readonly && localFormData.fault_phenomenon" class="readonly-text-display">
            {{ localFormData.fault_phenomenon }}
          </div>
          <!-- 编辑模式：显示下拉框 -->
          <a-select
            v-else
            v-model:value="localFormData.fault_phenomenon_id"
            placeholder="请选择故障现象"
            :loading="tagsLoading.fault_phenomenon"
            :disabled="readonly"
            @change="handleChange"
          >
            <a-select-option v-for="tag in faultPhenomenonTags" :key="tag.id" :value="tag.id">
              {{ tag.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="控制单元">
          <!-- 只读模式：显示文本 -->
          <div v-if="readonly && readonlyControlUnits.length > 0" class="readonly-text-display">
            <div v-for="(item, index) in readonlyControlUnits" :key="index">
              {{ index + 1 }}. {{ item }}
            </div>
          </div>
          <!-- 编辑模式：显示下拉框 -->
          <a-row v-else :gutter="8">
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.control_unit.type_id"
                placeholder="一级"
                :loading="tagsLoading.control_unit"
                :disabled="readonly"
                @focus="ensureTagTypeLoaded('CONTROL_UNIT')"
                @change="handleControlUnitChange('level1')"
              >
                <a-select-option v-for="tag in controlUnitLevel1" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.control_unit.brand_id"
                placeholder="二级"
                :loading="tagsLoading.control_unit"
                :disabled="readonly || !localFormData.control_unit.type_id || controlUnitLevel2.length === 0"
                @change="handleControlUnitChange('level2')"
              >
                <a-select-option v-for="tag in controlUnitLevel2" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.control_unit.model_id"
                placeholder="三级"
                :loading="tagsLoading.control_unit"
                :disabled="readonly || !localFormData.control_unit.brand_id || controlUnitLevel3.length === 0"
                @change="handleControlUnitChange('level3')"
              >
                <a-select-option v-for="tag in controlUnitLevel3" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item label="发动机信息">
          <!-- 只读模式：显示文本 -->
          <div v-if="readonly && localFormData.engine_info" class="readonly-text-display">
            {{ localFormData.engine_info }}
          </div>
          <!-- 编辑模式：显示下拉框 -->
          <a-select
            v-else
            v-model:value="localFormData.engine_info_id"
            placeholder="请选择发动机信息"
            :loading="tagsLoading.engine_info"
            :disabled="readonly"
            @focus="ensureTagTypeLoaded('ENGINE_INFO')"
            @change="handleChange"
          >
            <a-select-option v-for="tag in engineInfoTags" :key="tag.id" :value="tag.id">
              {{ tag.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="整车信息">
          <!-- 只读模式：显示文本 -->
          <div v-if="readonly && localFormData.vehicle_info.tag_value" class="readonly-text-display">
            {{ localFormData.vehicle_info.tag_value }}
          </div>
          <!-- 编辑模式：显示下拉框 -->
          <a-row v-else :gutter="8">
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.vehicle_info.type_id"
                placeholder="一级"
                :loading="tagsLoading.vehicle_info"
                :disabled="readonly"
                @focus="ensureTagTypeLoaded('VEHICLE_INFO')"
                @change="handleVehicleInfoChange('level1')"
              >
                <a-select-option v-for="tag in vehicleInfoLevel1" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.vehicle_info.brand_id"
                placeholder="二级"
                :loading="tagsLoading.vehicle_info"
                :disabled="readonly || !localFormData.vehicle_info.type_id || vehicleInfoLevel2.length === 0"
                @change="handleVehicleInfoChange('level2')"
              >
                <a-select-option v-for="tag in vehicleInfoLevel2" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.vehicle_info.model_id"
                placeholder="三级"
                :loading="tagsLoading.vehicle_info"
                :disabled="readonly || !localFormData.vehicle_info.brand_id || vehicleInfoLevel3.length === 0"
                @change="handleVehicleInfoChange('level3')"
              >
                <a-select-option v-for="tag in vehicleInfoLevel3" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item label="子系统信息">
          <!-- 只读模式：显示文本 -->
          <div v-if="readonly && localFormData.subsystem_info.tag_value" class="readonly-text-display">
            {{ localFormData.subsystem_info.tag_value }}
          </div>
          <!-- 编辑模式：显示下拉框 -->
          <a-row v-else :gutter="8">
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.subsystem_info.type_id"
                placeholder="一级"
                :loading="tagsLoading.subsystem_info"
                :disabled="readonly"
                @focus="ensureTagTypeLoaded('SUBSYSTEM_INFO')"
                @change="handleSubsystemInfoChange('level1')"
              >
                <a-select-option v-for="tag in subsystemInfoLevel1" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.subsystem_info.brand_id"
                placeholder="二级"
                :loading="tagsLoading.subsystem_info"
                :disabled="readonly || !localFormData.subsystem_info.type_id || subsystemInfoLevel2.length === 0"
                @change="handleSubsystemInfoChange('level2')"
              >
                <a-select-option v-for="tag in subsystemInfoLevel2" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.subsystem_info.model_id"
                placeholder="三级"
                :loading="tagsLoading.subsystem_info"
                :disabled="readonly || !localFormData.subsystem_info.brand_id || subsystemInfoLevel3.length === 0"
                @change="handleSubsystemInfoChange('level3')"
              >
                <a-select-option v-for="tag in subsystemInfoLevel3" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item label="部件信息">
          <!-- 只读模式：显示文本 -->
          <div v-if="readonly && localFormData.component_info.tag_value" class="readonly-text-display">
            {{ localFormData.component_info.tag_value }}
          </div>
          <!-- 编辑模式：显示下拉框 -->
          <a-row v-else :gutter="8">
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.component_info.type_id"
                placeholder="一级"
                :loading="tagsLoading.component_info"
                :disabled="readonly"
                @focus="ensureTagTypeLoaded('COMPONENT_INFO')"
                @change="handleComponentInfoChange('level1')"
              >
                <a-select-option v-for="tag in componentInfoLevel1" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.component_info.brand_id"
                placeholder="二级"
                :loading="tagsLoading.component_info"
                :disabled="readonly || !localFormData.component_info.type_id || componentInfoLevel2.length === 0"
                @change="handleComponentInfoChange('level2')"
              >
                <a-select-option v-for="tag in componentInfoLevel2" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <a-select
                v-model:value="localFormData.component_info.model_id"
                placeholder="三级"
                :loading="tagsLoading.component_info"
                :disabled="readonly || !localFormData.component_info.brand_id || componentInfoLevel3.length === 0"
                @change="handleComponentInfoChange('level3')"
              >
                <a-select-option v-for="tag in componentInfoLevel3" :key="tag.id" :value="tag.id">
                  {{ tag.name }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item label="系统电压">
          <!-- 只读模式：显示文本 -->
          <div v-if="readonly && localFormData.system_voltage" class="readonly-text-display">
            {{ localFormData.system_voltage }}
          </div>
          <!-- 编辑模式：显示下拉框 -->
          <a-select
            v-else
            v-model:value="localFormData.system_voltage_id"
            placeholder="请选择系统电压（默认24V）"
            :loading="tagsLoading.system_voltage"
            :disabled="readonly"
            @focus="ensureTagTypeLoaded('SYSTEM_VOLTAGE')"
            @change="handleChange"
          >
            <a-select-option v-for="tag in systemVoltageTags" :key="tag.id" :value="tag.id">
              {{ tag.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import { ref, watch, onMounted, computed } from 'vue';
import { getTags } from '../../api/promptSimulator';
import { formatControlUnitDisplayList } from './inputFormDisplay';
import { getInitialPrefetchTagTypes } from './inputFormTagStrategy';

export default {
  name: 'InputForm',
  props: {
    formData: {
      type: Object,
      default: () => ({
        fault_phenomenon_id: null,
        fault_phenomenon: null,
        control_unit: {
          type_id: null,
          brand_id: null,
          model_id: null,
          type_name: null,
          brand_name: null,
          model_name: null,
          tag_value: null
        },
        control_units: [],
        engine_info_id: null,
        engine_info: null,
        vehicle_info: {
          type_id: null,
          brand_id: null,
          model_id: null,
          type_name: null,
          brand_name: null,
          model_name: null,
          tag_value: null
        },
        subsystem_info: {
          type_id: null,
          brand_id: null,
          model_id: null,
          type_name: null,
          brand_name: null,
          model_name: null,
          tag_value: null
        },
        component_info: {
          type_id: null,
          brand_id: null,
          model_id: null,
          type_name: null,
          brand_name: null,
          model_name: null,
          tag_value: null
        },
        system_voltage_id: null,
        system_voltage: null
      })
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:formData', 'change'],
  setup(props, { emit }) {
    const localFormData = ref({ ...props.formData });
    const readonlyControlUnits = computed(() => formatControlUnitDisplayList(localFormData.value));
    const tagCache = new Map();

    const faultPhenomenonTags = ref([]);
    const controlUnitLevel1 = ref([]);
    const controlUnitLevel2 = ref([]);
    const controlUnitLevel3 = ref([]);
    const engineInfoTags = ref([]);
    const vehicleInfoLevel1 = ref([]);
    const vehicleInfoLevel2 = ref([]);
    const vehicleInfoLevel3 = ref([]);
    const subsystemInfoLevel1 = ref([]);
    const subsystemInfoLevel2 = ref([]);
    const subsystemInfoLevel3 = ref([]);
    const componentInfoLevel1 = ref([]);
    const componentInfoLevel2 = ref([]);
    const componentInfoLevel3 = ref([]);
    const systemVoltageTags = ref([]);

    const tagsLoading = ref({
      fault_phenomenon: false,
      control_unit: false,
      engine_info: false,
      vehicle_info: false,
      subsystem_info: false,
      component_info: false,
      system_voltage: false
    });

    const ensureDefaultSystemVoltage = () => {
      if (localFormData.value.system_voltage_id) return;
      const default24V = systemVoltageTags.value.find(t => t.name && t.name.includes('24'));
      if (default24V) {
        localFormData.value.system_voltage_id = default24V.id;
      }
    };

    const fetchTags = async (tagTypeCode, loadingKey) => {
      if (tagCache.has(tagTypeCode)) {
        return tagCache.get(tagTypeCode);
      }

      if (loadingKey) {
        tagsLoading.value[loadingKey] = true;
      }
      try {
        const result = await getTags(tagTypeCode);
        const tags = result.code === 200 ? (result.data || []) : [];
        tagCache.set(tagTypeCode, tags);
        return tags;
      } catch (error) {
        console.error(`加载${tagTypeCode}标签失败:`, error);
        return [];
      } finally {
        if (loadingKey) {
          tagsLoading.value[loadingKey] = false;
        }
      }
    };

    // 加载联动标签的子级选项（用于历史记录回填）
    const loadCascadeOptions = async () => {
      // 控制单元
      if (localFormData.value.control_unit.type_id) {
        await loadChildTags('CONTROL_UNIT', 'control_unit', localFormData.value.control_unit.type_id, controlUnitLevel2);
        if (localFormData.value.control_unit.brand_id) {
          await loadChildTags('CONTROL_UNIT', 'control_unit', localFormData.value.control_unit.brand_id, controlUnitLevel3);
        }
      }
      
      // 整车信息
      if (localFormData.value.vehicle_info.type_id) {
        await loadChildTags('VEHICLE_INFO', 'vehicle_info', localFormData.value.vehicle_info.type_id, vehicleInfoLevel2);
        if (localFormData.value.vehicle_info.brand_id) {
          await loadChildTags('VEHICLE_INFO', 'vehicle_info', localFormData.value.vehicle_info.brand_id, vehicleInfoLevel3);
        }
      }
      
      // 子系统信息
      if (localFormData.value.subsystem_info.type_id) {
        await loadChildTags('SUBSYSTEM_INFO', 'subsystem_info', localFormData.value.subsystem_info.type_id, subsystemInfoLevel2);
        if (localFormData.value.subsystem_info.brand_id) {
          await loadChildTags('SUBSYSTEM_INFO', 'subsystem_info', localFormData.value.subsystem_info.brand_id, subsystemInfoLevel3);
        }
      }
      
      // 部件信息
      if (localFormData.value.component_info.type_id) {
        await loadChildTags('COMPONENT_INFO', 'component_info', localFormData.value.component_info.type_id, componentInfoLevel2);
        if (localFormData.value.component_info.brand_id) {
          await loadChildTags('COMPONENT_INFO', 'component_info', localFormData.value.component_info.brand_id, componentInfoLevel3);
        }
      }
    };

    // 监听props变化
    watch(() => props.formData, async (newVal) => {
      localFormData.value = { ...newVal };
      // 当表单数据变化时，如果有联动标签的ID，自动加载子级选项
      if (!props.readonly) {
        await loadCascadeOptions();
      }
    }, { deep: true });

    // 加载标签
    const loadTags = async (tagTypeCode, refName, loadingKey) => {
      const tags = await fetchTags(tagTypeCode, loadingKey);
      if (refName === 'controlUnitLevel1') {
        // 控制单元需要特殊处理，只显示第一级
        controlUnitLevel1.value = tags.filter(t => !t.parent_id || t.parent_id === 0);
      } else if (refName === 'vehicleInfoLevel1') {
        // 整车信息需要特殊处理，只显示第一级
        vehicleInfoLevel1.value = tags.filter(t => !t.parent_id || t.parent_id === 0);
      } else if (refName === 'subsystemInfoLevel1') {
        // 子系统信息需要特殊处理，只显示第一级
        subsystemInfoLevel1.value = tags.filter(t => !t.parent_id || t.parent_id === 0);
      } else if (refName === 'componentInfoLevel1') {
        // 部件信息需要特殊处理，只显示第一级
        componentInfoLevel1.value = tags.filter(t => !t.parent_id || t.parent_id === 0);
      } else if (refName === 'faultPhenomenonTags') {
        faultPhenomenonTags.value = tags;
      } else if (refName === 'engineInfoTags') {
        engineInfoTags.value = tags;
      } else if (refName === 'systemVoltageTags') {
        systemVoltageTags.value = tags;
        ensureDefaultSystemVoltage();
      }
    };

    // 通用函数：加载子级标签并判断是否为最终级别
    // tagTypeCode: API标签类型代码（如 'CONTROL_UNIT'）
    // loadingKey: loading状态的键（如 'control_unit'）
    const loadChildTags = async (tagTypeCode, loadingKey, parentId, levelRef) => {
      if (!parentId) {
        levelRef.value = [];
        return { hasChildren: false };
      }
      const allTags = await fetchTags(tagTypeCode, loadingKey);
      const children = allTags.filter(t => t.parent_id === parentId);
      levelRef.value = children;
      return { hasChildren: children.length > 0 };
    };

    const ensureTagTypeLoaded = async (tagTypeCode) => {
      switch (tagTypeCode) {
        case 'FAULT_PHENOMENON':
          await loadTags('FAULT_PHENOMENON', 'faultPhenomenonTags', 'fault_phenomenon');
          break;
        case 'CONTROL_UNIT':
          await loadTags('CONTROL_UNIT', 'controlUnitLevel1', 'control_unit');
          break;
        case 'ENGINE_INFO':
          await loadTags('ENGINE_INFO', 'engineInfoTags', 'engine_info');
          break;
        case 'VEHICLE_INFO':
          await loadTags('VEHICLE_INFO', 'vehicleInfoLevel1', 'vehicle_info');
          break;
        case 'SUBSYSTEM_INFO':
          await loadTags('SUBSYSTEM_INFO', 'subsystemInfoLevel1', 'subsystem_info');
          break;
        case 'COMPONENT_INFO':
          await loadTags('COMPONENT_INFO', 'componentInfoLevel1', 'component_info');
          break;
        case 'SYSTEM_VOLTAGE':
          await loadTags('SYSTEM_VOLTAGE', 'systemVoltageTags', 'system_voltage');
          break;
        default:
          break;
      }
    };

    const loadInitialTags = async () => {
      const initialTagTypes = getInitialPrefetchTagTypes(props.readonly);
      if (initialTagTypes.length === 0) return;
      await Promise.all(initialTagTypes.map(type => ensureTagTypeLoaded(type)));
    };

    watch(() => props.readonly, async (isReadonly) => {
      if (!isReadonly) {
        await loadInitialTags();
        await loadCascadeOptions();
      }
    });


    // 控制单元变化处理（动态判断是否为最终级别）
    const handleControlUnitChange = async (level) => {
      if (level === 'level1') {
        localFormData.value.control_unit.brand_id = null;
        localFormData.value.control_unit.model_id = null;
        controlUnitLevel2.value = [];
        controlUnitLevel3.value = [];
        const result = await loadChildTags('CONTROL_UNIT', 'control_unit', localFormData.value.control_unit.type_id, controlUnitLevel2);
        // 先更新表单数据（但不触发change事件）
        emit('update:formData', { ...localFormData.value });
        // 如果二级有数据，不触发匹配（需要继续选择二级和三级）
        // 如果二级没有数据，可以触发匹配（如：天然气ECU）
        if (result.hasChildren === false && controlUnitLevel2.value.length === 0) {
          // 二级没有数据，可以触发匹配
          handleChange();
        }
        // 如果二级有数据（result.hasChildren === true 或 controlUnitLevel2.value.length > 0），不触发匹配，等待用户继续选择
      } else if (level === 'level2') {
        localFormData.value.control_unit.model_id = null;
        controlUnitLevel3.value = [];
        const result = await loadChildTags('CONTROL_UNIT', 'control_unit', localFormData.value.control_unit.brand_id, controlUnitLevel3);
        // 先更新表单数据（但不触发change事件）
        emit('update:formData', { ...localFormData.value });
        // 如果三级有数据，不触发匹配（需要继续选择三级）
        // 如果三级没有数据，可以触发匹配
        if (result.hasChildren === false && controlUnitLevel3.value.length === 0) {
          // 三级没有数据，可以触发匹配
          handleChange();
        }
        // 如果三级有数据（result.hasChildren === true 或 controlUnitLevel3.value.length > 0），不触发匹配，等待用户继续选择
      } else if (level === 'level3') {
        // 三级是最后一级，选择完直接触发匹配
        emit('update:formData', { ...localFormData.value });
        handleChange();
      }
    };

    // 整车信息变化处理（动态判断是否为最终级别）
    const handleVehicleInfoChange = async (level) => {
      if (level === 'level1') {
        localFormData.value.vehicle_info.brand_id = null;
        localFormData.value.vehicle_info.model_id = null;
        vehicleInfoLevel2.value = [];
        vehicleInfoLevel3.value = [];
        const result = await loadChildTags('VEHICLE_INFO', 'vehicle_info', localFormData.value.vehicle_info.type_id, vehicleInfoLevel2);
        emit('update:formData', { ...localFormData.value });
        // 只有在真正没有子级时，才触发匹配
        if (result.hasChildren === false && vehicleInfoLevel2.value.length === 0) {
          handleChange();
        }
      } else if (level === 'level2') {
        localFormData.value.vehicle_info.model_id = null;
        vehicleInfoLevel3.value = [];
        const result = await loadChildTags('VEHICLE_INFO', 'vehicle_info', localFormData.value.vehicle_info.brand_id, vehicleInfoLevel3);
        emit('update:formData', { ...localFormData.value });
        // 只有在真正没有子级时，才触发匹配
        if (result.hasChildren === false && vehicleInfoLevel3.value.length === 0) {
          handleChange();
        }
      } else if (level === 'level3') {
        // 三级是最后一级，直接触发匹配
        handleChange();
      }
    };

    // 子系统信息变化处理（动态判断是否为最终级别）
    const handleSubsystemInfoChange = async (level) => {
      if (level === 'level1') {
        localFormData.value.subsystem_info.brand_id = null;
        localFormData.value.subsystem_info.model_id = null;
        subsystemInfoLevel2.value = [];
        subsystemInfoLevel3.value = [];
        const result = await loadChildTags('SUBSYSTEM_INFO', 'subsystem_info', localFormData.value.subsystem_info.type_id, subsystemInfoLevel2);
        emit('update:formData', { ...localFormData.value });
        // 只有在真正没有子级时，才触发匹配
        if (result.hasChildren === false && subsystemInfoLevel2.value.length === 0) {
          handleChange();
        }
      } else if (level === 'level2') {
        localFormData.value.subsystem_info.model_id = null;
        subsystemInfoLevel3.value = [];
        const result = await loadChildTags('SUBSYSTEM_INFO', 'subsystem_info', localFormData.value.subsystem_info.brand_id, subsystemInfoLevel3);
        emit('update:formData', { ...localFormData.value });
        // 只有在真正没有子级时，才触发匹配
        if (result.hasChildren === false && subsystemInfoLevel3.value.length === 0) {
          handleChange();
        }
      } else if (level === 'level3') {
        // 三级是最后一级，直接触发匹配
        handleChange();
      }
    };

    // 部件信息变化处理（动态判断是否为最终级别）
    const handleComponentInfoChange = async (level) => {
      if (level === 'level1') {
        localFormData.value.component_info.brand_id = null;
        localFormData.value.component_info.model_id = null;
        componentInfoLevel2.value = [];
        componentInfoLevel3.value = [];
        const result = await loadChildTags('COMPONENT_INFO', 'component_info', localFormData.value.component_info.type_id, componentInfoLevel2);
        emit('update:formData', { ...localFormData.value });
        // 只有在真正没有子级时，才触发匹配
        if (result.hasChildren === false && componentInfoLevel2.value.length === 0) {
          handleChange();
        }
      } else if (level === 'level2') {
        localFormData.value.component_info.model_id = null;
        componentInfoLevel3.value = [];
        const result = await loadChildTags('COMPONENT_INFO', 'component_info', localFormData.value.component_info.brand_id, componentInfoLevel3);
        emit('update:formData', { ...localFormData.value });
        // 只有在真正没有子级时，才触发匹配
        if (result.hasChildren === false && componentInfoLevel3.value.length === 0) {
          handleChange();
        }
      } else if (level === 'level3') {
        // 三级是最后一级，直接触发匹配
        handleChange();
      }
    };

    // 表单变化处理
    const handleChange = () => {
      emit('update:formData', { ...localFormData.value });
      emit('change');
    };

    // 初始化加载标签
    onMounted(async () => {
      await loadInitialTags();
      if (!props.readonly) {
        await loadCascadeOptions();
      }
    });

    return {
      localFormData,
      readonlyControlUnits,
      faultPhenomenonTags,
      controlUnitLevel1,
      controlUnitLevel2,
      controlUnitLevel3,
      engineInfoTags,
      vehicleInfoLevel1,
      vehicleInfoLevel2,
      vehicleInfoLevel3,
      subsystemInfoLevel1,
      subsystemInfoLevel2,
      subsystemInfoLevel3,
      componentInfoLevel1,
      componentInfoLevel2,
      componentInfoLevel3,
      systemVoltageTags,
      tagsLoading,
      ensureTagTypeLoaded,
      handleChange,
      handleControlUnitChange,
      handleVehicleInfoChange,
      handleSubsystemInfoChange,
      handleComponentInfoChange
    };
  }
};
</script>

<style scoped>
.input-form {
  margin-bottom: 16px;
}

.readonly-text-display {
  padding: 4px 11px;
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  min-height: 32px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}
</style>

